import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const propTypes = {
  onClick: PropTypes.func.isRequired,
  refunded: PropTypes.bool,
};

const defaultProps = {
  refunded: false,
};


const ExpandDetails = ({ onClick, refunded }) => {
  const buttonClasses = cx({
    'btn': true,
    'btn-block': true,
    'btn-alternate': true,
    'btn-blue': !refunded,
    'btn-red': refunded,
    'btn-disabled': refunded,
  });
  const text = refunded ? 'Refunded' : '+ View Details';
  return (
    <a onClick={onClick} className={buttonClasses}>
      {text}
    </a>
  );
};

ExpandDetails.propTypes = propTypes;
ExpandDetails.defaultProps = defaultProps;
export default ExpandDetails;
